export default __webpack_public_path__ + "static/wedding_2-4add6a7a60a7b8cea7cb59d3bd1918bc.png";